export enum Tracking {
  MODAL_LINK = 'clickedMoreDetailsLink',
  FAQ_LINK = 'clickedFAQLink',
  EXTERNAL_LINK = 'clickedExternalLink',
}

export enum OptimiseProgramme {
  CASHBACK = 'CASHBACK',
  DISCOUNT_CODE = 'DISCOUNT_CODE',
  OTHER = 'OTHER',
}
